import { useSearch } from "@tanstack/react-router";

export function SearchErrorBoundary() {
  const search = useSearch({ strict: false }) as { query?: string };
  const query = search?.query;

  return (
    <main id="main" className="max-w-[1440px] mx-auto p-8 bg-bg-brand-secondary-default">
      <h1 className="title-m-bold mb-4">
        {query ? `Search results for "${query}"` : "Search"}
      </h1>
      <p className="body-m-regular text-fg-neutral-subtle">Loading...</p>
    </main>
  );
}
